export default __webpack_public_path__ + "static/media/star.0667c275.svg";